import React, { Component } from "react";
import LayoutBase from "./layout-base";

export default class GlobalLayout extends Component {
  render() {
    return (
      <LayoutBase location={this.props.location}>
        <main className="uk-container" id="contentContainer">
          {this.props.children}
        </main>
      </LayoutBase>
    );
  }
}
